<template>
  <div>
    <div id="market-item-container">
      <div id="main-image" v-bind:style="{ backgroundImage: `url('${currentPhoto}')` }">
        <!-- <img id="big-img" v-bind:src="currentPhoto" /> -->
        <!-- <img class="more" src="../assets/images/More.svg" /> -->
        <i class="rds-icon rds-icon-more"></i>
      </div>
      <div id="scrolling-img">
        <div id="img-container">
          <div
            class="small-img"
            v-on:tap="currentPhoto = item"
            v-for="(item, i) in filteredPhotos"
            v-bind:key="i"
          >
            <img v-bind:src="item" />
          </div>
        </div>
      </div>
      <div id="description-box">
        <div id="price-box">
          <span>{{product.price}}€</span>
          <div class="like-container" v-on:tap="toggleLike">
            <LikeHeart v-bind:class="{'user-like':userLike}"></LikeHeart>
            <!-- <img src="../assets/images/cuore2.svg" /> -->
          </div>

          <!-- <i class="rds-icon rds-icon-like"></i> -->
        </div>
        <!-- <p id="item-desc">{{product.description}}</p> -->
        <div id="item-title">{{product.title}}</div>
        <div id="item-category">categoria</div>
        <div id="item-desc">{{product.description}}</div>
      </div>
      <div id="user-info">
        <div
          v-if="product.user && product.user.photos && product.user.photos.length"
          class="profile-img"
          v-bind:class="{google : product.user.photos[0].indexOf('googleusercontent')!==-1|| product.user.photos[0].indexOf('placeholder_img_profilo')!==-1}"
        >
          <!-- <img id="profile-img" v-if="product.user.photos" v-bind:src="product.user.photos[0]" /> -->
          <img v-bind:src="product.user.photos[0]" />
        </div>
        <div class="name">
          <span>{{ userName }}</span>
        </div>
        <div id="overlapping">
          <div
            class="overlapping-profile-img"
            v-for="(img, idx) in usersThatLikesImg"
            v-bind:key="idx"
          >
            <img v-bind:src="img" />
          </div>
          <div v-if="otherLikesNumber>1" class="overlapping-profile-img" id="last-img">
            <span>+{{otherLikesNumber}}</span>
          </div>
        </div>
      </div>
      <div v-if="!isCurrentUser" id="contatti-box">
        <button>
          <a v-bind:href="phoneHref">Chiama</a>
        </button>
        <button>
          <a v-bind:href="mailHref">Scrivi</a>
        </button>
      </div>
      <div v-else id="contatti-box">
        <button v-on:tap="editProduct">
          <span>Modifica</span>
        </button>
        <button v-on:tap="removeProduct">
          <span>Elimina</span>
        </button>
      </div>
      <br />
    </div>
  </div>
</template>

<script>
import userService from '../services/User.service';
import LikeHeart from '../components/LikeHeart';
import store from '../stores';
import emums from '../enums/RdsLife.enums';
const LIKES_IMAGES_LIMIT = 1;
export default {
  name: 'marketItem',
  components: { LikeHeart },
  props: ['product'],
  data() {
    return {
      currentPhoto: null,
      userId: userService.user.id,
      usersThatLikes: [],
      fixMailHref: '',
      fixPhoneHref: ''
    };
  },
  methods: {
    toggleLike() {
      const added = userService.toggleLike('products', this.product.id);
      if (added) {
        this.product.likes.push(userService.user.id);
      } else {
        this.product.likes.splice(
          this.product.likes.indexOf(userService.user.id),
          1
        );
      }
      store.update('marketProduct', this.product.id, this.product);
    },
    removeProduct() {
      console.log('removeProduct');
      store.remove('marketProduct', this.product.id).then(() => {
        console.log('removeProduct then');
        this.$emit('productRemove', this.product.id);
      });
    },
    editProduct() {
      console.log('editProduct');
      this.$emit('editProduct', this.product);
    }
  },
  computed: {
    isCurrentUser() {
      return (
        this.product.user.id === userService.user.id ||
        this.product.user.name === userService.user.name
      );
    },
    userName() {
      try {
        return this.product.user.name;
      } catch (error) {
        return '';
      }
    },
    mailHref() {
      let href = '';
      try {
        const contact = this.product.user.contacts.find(c => c.key === 'Email');
        if (!!contact) {
          href = 'mailto:' + contact.value;
        }
      } catch (error) {
        console.warn(error);
        return this.fixMailHref;
      }
      return href;
    },
    phoneHref() {
      let href = '';
      try {
        console.log(this.product.user.contacts);

        const contact = this.product.user.contacts.find(
          c => c.key === 'Tel. Interno'
        );
        if (!!contact && !!contact.value) {
          href = 'tel:+39' + contact.value;
        }
      } catch (error) {
        console.warn(error);
        return this.fixPhoneHref;
      }
      return href;
    },
    userLike() {
      console.log(this.product);
      return (
        Array.isArray(this.product.likes) &&
        this.product.likes.indexOf(userService.user.id) !== -1
      );
    },
    otherLikesNumber() {
      return this.usersThatLikes.length - LIKES_IMAGES_LIMIT;
    },
    usersThatLikesImg() {
      return this.usersThatLikes
        .map(u => u.photos[0])
        .filter((up, i) => i < LIKES_IMAGES_LIMIT);
    },
    filteredPhotos: function() {
      return this.product.photos;
    }
  },
  mounted() {
    console.log(this.product);
    this.currentPhoto = this.product.photos[0];
    console.log(this.currentPhoto);

    store
      .getAll(emums.modelTypes.RDS_USER)
      .then(users => {
        if (!this.product.user) {
          this.product.user = { name: 'Davide Russo' };
        }
        let u = users.find(u => this.product.user.name === u.name);
        console.log(u);
        console.log(userService.user);

        if (!u) {
          u = users.find(u => u.name === 'Davide Russo');
          console.log(this.product.user);
        }
        this.product.user = u;

        const telContact = this.product.user.contacts.find(
          c => c.key === 'Tel. Interno'
        );
        if (!!telContact && !!telContact.value) {
          this.fixPhoneHref = 'tel:+39' + telContact.value;
        }
        const mailContact = this.product.user.contacts.find(
          c => c.key === 'Email'
        );
        if (!!mailContact && !!mailContact.value) {
          this.fixMailHref = 'tel:+39' + mailContact.value;
        }
        return users.filter(
          u =>
            !!u.likes &&
            !!u.likes.products &&
            u.id !== userService.user.id &&
            u.likes.products.indexOf(this.product.id) !== -1
        );
      })
      .then(u => {
        this.usersThatLikes = u;
      });
  }
};
</script>
<style lang="scss" scoped>
.rds-icon-like {
  color: rgba(163, 19, 19, 1);
  font-size: 2em;
}
#market-item-container {
  padding: $default-padding;
  #main-image {
    // background-size: cover;
    background-size: contain;
    background-repeat: no-repeat;
    background-position-x: center;
    min-height: 274px;
    max-height: 274px;
    height: 274px;
    border-radius: $default-border-radius;
  }
  #item-title {
    font-weight: 600;
  }
  #item-category {
    font-size: 0.75em;
    margin-top: 16px;
  }
  #item-desc {
    margin: 16px 0;
    font-size: 0.95em;
    line-height: 19px;
  }
  .like-container {
    width: 18px;
    display: flex;
    padding-left: 12px;
  }
  .profile-img {
    width: 42px;
    max-width: 42px;
    min-width: 42px;
    overflow: hidden;
    border-radius: 50%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    img {
      height: 42px;
      max-width: none;
      position: relative;
      right: 50%;
    }
  }

  .google.profile-img {
    $size: 42px;
    min-width: $size;
    max-width: $size;
    img {
      border-radius: 50%;
      width: 100%;
      position: inherit;
    }
  }
  .overlapping-profile-img {
    width: 25px;
    max-width: none;
    overflow: hidden;
    border-radius: 50%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    img {
      height: 25px;
      max-width: none;
      position: relative;
      right: 50%;
    }
  }

  .google.overlapping-profile-img {
    $size: 25px;
    width: $size;
    img {
      border-radius: 50%;
    }
    &#last-img {
      background: black;
      width: $size;
      height: $size;
      border-radius: 50%;
      position: relative;
      color: white;
      font-size: 0.7em;
      display: flex;
      justify-content: center;
      align-content: center;
      align-items: center;
    }
  }
  a,
  #contatti-box span {
    text-decoration: none;
    color: #707070;
  }
  // .small-img {
  //   max-width: 170px;
  //   width: 100%;
  //   overflow-x: hidden;
  // }
}
</style>
